/**
 * SOLOMON — SAVED MARKET CHIP
 *
 * Renders a single saved market as a clickable chip. Click → invokes
 * onLoad(market) which appends the market's identifiers to the parent
 * textarea (additive — operator can stack multiple markets in one search).
 * Hover reveals ✏ edit and × delete affordances.
 *
 * Props:
 *   market         — {id, name, identifiers}
 *   onLoad(market) — operator clicked the chip body
 *   onEdit(market) — operator clicked the ✏ icon
 *   onDelete(market) — operator clicked the ×
 */

export default function SavedMarketChip({ market, onLoad, onEdit, onDelete }) {
  const idSummary = summarizeIdentifiers(market.identifiers);
  return (
    <span className="ls-market-chip" title={`Click to add ${idSummary} to the search`}>
      <button
        type="button"
        className="ls-market-chip-body"
        onClick={() => onLoad(market)}
      >
        <span className="ls-market-chip-name">{market.name}</span>
        <span className="ls-market-chip-summary">{idSummary}</span>
      </button>
      <button
        type="button"
        className="ls-market-chip-action ls-market-chip-edit"
        onClick={() => onEdit(market)}
        title="Edit this market"
        aria-label={`Edit ${market.name}`}
      >
        ✏
      </button>
      <button
        type="button"
        className="ls-market-chip-action ls-market-chip-delete"
        onClick={() => onDelete(market)}
        title="Delete this market"
        aria-label={`Delete ${market.name}`}
      >
        ×
      </button>
    </span>
  );
}

function summarizeIdentifiers(identifiers) {
  if (!Array.isArray(identifiers) || identifiers.length === 0) return '(empty)';
  if (identifiers.length === 1) {
    const g = identifiers[0];
    if (g.type === 'zip')    return `ZIP ${g.value}`;
    if (g.type === 'city')   return `${g.value}, ${g.state}`;
    if (g.type === 'county') return `${g.value}, ${g.state}`;
    if (g.type === 'state')  return g.value;
    return '1 identifier';
  }
  return `${identifiers.length} identifiers`;
}
